import {
  ContactInfoCard,
  ContactInfoCardProps,
  EmptySectionCard,
  InquiryDetailSectionHeader,
  SkeletonLoader,
} from '@equip.health/ui';
import { Section } from '~/components/common/Section';

export interface ContactProps extends React.PropsWithChildren {
  contacts: ContactInfoCardProps[];
  id: string;
  isLoading: boolean;
}

export const Contacts = ({
  children,
  contacts,
  id,
  isLoading,
}: ContactProps) => {
  const TOPLEVEL_ID = `${id}__contacts`;

  const contactCards =
    contacts.length > 0 ? (
      contacts.map((contact) => {
        return <ContactInfoCard key={contact.id} {...contact} />;
      })
    ) : (
      <EmptySectionCard
        caption="No contacts have been added"
        id={TOPLEVEL_ID}
      />
    );

  return (
    <Section id={TOPLEVEL_ID}>
      <InquiryDetailSectionHeader id={`${TOPLEVEL_ID}-header`} title="Contacts">
        {children}
      </InquiryDetailSectionHeader>
      <SkeletonLoader id={TOPLEVEL_ID} isLoaded={!isLoading}>
        <Section id={`${TOPLEVEL_ID}-children`}>{contactCards}</Section>
      </SkeletonLoader>
    </Section>
  );
};
